export class StateProject {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}

export class StateProjectForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}